import { DiagonalCornerModel } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface DiagonalCornerState {
    selectedDiagonalCorner?: DiagonalCornerModel;
    isInteriorDiagonalCornerEnabled: boolean;
}

const initialState: DiagonalCornerState = {
    selectedDiagonalCorner: undefined,
    isInteriorDiagonalCornerEnabled: false,
};

export const diagonalCornerSlice = createSlice({
    name: 'diagonalCorner',
    initialState,
    reducers: {
        updateSelectedDiagonalCorner: (state, action: PayloadAction<DiagonalCornerModel>) => {
            state.selectedDiagonalCorner = action.payload;
        },
        updateIsInteriorDiagonalCornerEnabled: (state, action: PayloadAction<boolean>) => {
            state.isInteriorDiagonalCornerEnabled = action.payload;
        },
        resetSelectedDiagonalCorner: (state) => {
            state.selectedDiagonalCorner = undefined;
        },
    },
});

export default diagonalCornerSlice.reducer;

export const { resetSelectedDiagonalCorner, updateSelectedDiagonalCorner, updateIsInteriorDiagonalCornerEnabled } =
    diagonalCornerSlice.actions;

export const selectSelectedDiagonalCorner = ({ diagonalCorner }: RootState): DiagonalCornerModel | undefined =>
    diagonalCorner.selectedDiagonalCorner;

export const selectIsInteriorDiagonalCornerEnabled = ({ diagonalCorner }: RootState): boolean =>
    diagonalCorner.isInteriorDiagonalCornerEnabled;
